const _ = require('underscore');

/**
 * 関数の戻り値をキャッシュして、次回その関数が呼ばれた場合にキャッシュを返します
 *
 * this スコープの関係で、パラメータを戻り値に持つような関数を引数に取ります。
 * `key` は store に格納する際の key を生成する関数で、省略した場合は全ての引数を
 * ':' でジョインした値が使われます。
 * `store` はキャッシュ用のストレージ、func は対象となる関数をそれぞれ指定します。
 *
 * Cache(function() {
 *    return {
 *        key: (a, b) => {`${a}::${b}`},
 *        store: this._store,
 *        func: this.toCache
 *    }
 * })
 *
 * @param p
 * @returns {Function}
 */
module.exports = function(p) {
    return function(...args) {
        const params = _.bind(p, this)();
        const key = params.key ? params.key(...args) : args.join(':');
        let promise = params.store[key];
        if(!promise) {
            promise = params.func(...args);
            params.store[key] = promise;
        }
        return promise;
    };
};



// WEBPACK FOOTER //
// ./common/util/cacher.js